<template>
  <div
    v-if="showModal"
    id="sac-modal-overlay"
    :class="[
      modalClass,
    ]"
  >
    <div
      v-if="close"
      class="close-background"
      @click="hideModal"
      @keydown="hideModal"
    />
    <div
      :class="[
        'modal-card',
        dark ? 'dark' : '',
        show ? 'fade-in' : 'fade-out',
        cardClass,
      ]"
    >
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SACModal',
  props: {
    show: Boolean,
    dark: Boolean,
    close: Function,
    modalClass: String,
    cardClass: String,
  },
  data() {
    return {
      showModal: this.show,
    };
  },
  watch: {
    show(show) {
      if (!show) {
        setTimeout(() => {
          this.showModal = show;
          this.enableScroll();
        }, 200);
      } else {
        this.showModal = show;
        this.disableScroll();
      }
    },
  },
  beforeDestroy() {
    this.enableScroll();
  },
  methods: {
    hideModal() {
      if (this.close) {
        this.close();
      }
    },
    disableScroll() {
      document.documentElement.style.overflowY = 'hidden';
    },
    enableScroll() {
      document.documentElement.style.overflowY = 'auto';
    },
  },
};
</script>

<style lang="scss">

#sac-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(15, 23, 52, 0.75);
  .close-background {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }
  .modal-card {
    background-color: $WHITE;
    transition: all 0.25s ease;
    border-radius: 12px;
    position: absolute;
    z-index: 2;
    &.dark {
      background-color: black;
    }
    &.fade-in {
      animation-fill-mode: forwards;
      animation: fadeAndScaleIn 0.25s ease;
    }
    &.fade-out {
      animation-fill-mode: forwards;
      animation: fadeAndScaleOut 0.25s ease;
    }
  }
}

@keyframes fadeAndScaleIn {
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  50% {
    opacity: .25;
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes fadeAndScaleOut {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: .25;
  }
  100% {
    opacity: 0;
    transform: scale(0.9);
  }
}
</style>
